import * as React from 'react';
import Image from 'next/image';
import Link from 'next/link';

type Props = {
  image: string;
  title: string;
  subtitle: string;
  description: string;
};

const HeroBanner: React.FC<Props> = ({ image, title, subtitle, description }) => {
  return (
    <div
      className="ml-auto h-[400px] lg:h-[640px] mr-auto object-cover bg-cover bg-center relative z-50 rounded overflow-hidden p-32"
      style={{ width: 'calc(100% - 32px)' }}>
      {image && <Image src={image} layout="fill" objectFit="cover" className="rounded" priority alt="" />}

      <div className="w-full h-full absolute bg-black top-0 left-0 opacity-40" />

      <div className="w-full h-full px-8 lg:px-32 justify-center  flex-col flex absolute top-0 left-0">
        <h1 className="text-2xl md:text-5xl font-bold text-white mb-0">{title}</h1>
        <h1 className="text-sm md:text-xl font-bold text-white mb-3 md:mb-6">{subtitle}</h1>
        <h2 className="text-sm md:text-lg font-medium leading-5 md:leading-7 text-white max-w-xs md:max-w-lg mb-12">{description}</h2>

        <Link href="https://onelink.to/9vn2ca" passHref>
          <a className="xplore-btn w-[200px] md:w-[250px]" target="_blank">
            Download App – Íoslódáil
          </a>
        </Link>
      </div>
    </div>
  );
};

export default HeroBanner;
